/** @format */

import * as React from 'react';
//@ts-ignore
import { StyleSheet, View, Platform, Animated } from 'react-native';
import Images from '../images';
//@ts-ignore
import { observer } from 'mobx-react';
//@ts-ignore
import { JDNativeSystem, JDDevice, JDText, JDScrollView, JDImage, JDTouchable } from '@jdreact/jdreact-core-lib';
//@ts-ignore
import LinearGradient from '@jdreact/jdreact-core-linear-gradient';
import Store from '../services/goodsContrastPageStore/store';
import { AvailableCouponsItem } from '../services/goodsContrastPageStore/domain';
import { logClick, ContrastCoupon, ContrastConfirm } from '../mta/MtaService';
import { ITicket } from '../services/goodsContrastPageStore/domain';

const { getRpx, getFontSize } = JDDevice;
const h = JDNativeSystem.isIPhoneX ? getRpx(78) : getRpx(100);
const styles = StyleSheet.create({
  ticketLayer: {
    position: Platform.OS === 'web' ? 'fixed' : 'absolute',
    top: 0,
    left: 0,
    elevation: 10,
    width: getRpx(750),
    height: '100%',
    zIndex: 20,
  },
  mask: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: getRpx(750),
    height: '100%',
    backgroundColor: '#000000',
    zIndex: 10,
  },
  coupon: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    flexDirection: 'column',
    width: getRpx(750),
    height: getRpx(1266),
    paddingBottom: JDNativeSystem.isIPhoneX ? getRpx(78) : getRpx(100),
    borderTopLeftRadius: getRpx(24),
    borderTopRightRadius: getRpx(24),
    backgroundColor: '#ffffff',
    overflow: 'hidden',
    zIndex: 11,
  },
  couponHead: {
    height: getRpx(112),
    justifyContent: 'center',
    alignItems: 'center',
  },
  dialogCloseClick: {
    position: 'absolute',
    right: getRpx(26),
    top: getRpx(38),
  },
  dialogClose: {
    width: getRpx(40),
    height: getRpx(40),
  },
  dialogInner: {
    height: Platform.OS == 'web' ? getRpx(820) : getRpx(1054) - h,
  },
  dialogContent: {
    flexDirection: 'column',
    alignItems: 'center',
    paddingTop: getRpx(48),
  },
  ticket: {
    flexDirection: 'row',
    width: getRpx(702),
    height: getRpx(200),
    borderStartWidth: 1,
    borderStyle: 'solid',
    borderColor: '#F7F7F7',
    borderRadius: getRpx(8),
    overflow: 'visible',
    marginBottom: getRpx(24),
  },
  ticketValue: {},
  ticketValueBg: {
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: getRpx(208),
    minHeight: getRpx(200),
    borderTopLeftRadius: getRpx(8),
    borderBottomLeftRadius: getRpx(8),
    overflow: 'hidden',
  },
  ticketPrice: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'flex-end',
    height: getRpx(60),
    marginBottom: getRpx(16),
  },
  ticketColorWhite: {
    color: '#ffffff',
  },
  ticketPriceSymbol: {
    alignItems: 'flex-end',
    fontSize: getRpx(40),
    fontWeight: 'bold',
    height: Platform.OS == 'android' ? getRpx(45) : getRpx(40),
  },
  ticketPriceNum: {
    alignItems: 'flex-end',
    fontSize: getRpx(60),
    fontWeight: 'bold',
    height: Platform.OS == 'android' ? getRpx(70) : getRpx(60),
  },
  ticketPriceRange: {
    fontSize: getRpx(24),
  },
  ticketInfo: {
    flexDirection: 'column',
    width: getRpx(494),
    height: getRpx(200),
    paddingLeft: getRpx(24),
    elevation: 4,
    shadowOffset: {
      width: 0,
      height: getRpx(4),
    },
    shadowColor: '#000000',
    shadowOpacity: 0.04,
    shadowRadius: getRpx(12),
    overflow: 'visible',
    backgroundColor: '#ffffff',
    borderTopRightRadius: getRpx(8),
    borderBottomRightRadius: getRpx(8),
  },
  ticketShadow: {
    position: 'absolute',
    top: -getRpx(16),
    left: 0,
    width: getRpx(506),
    height: getRpx(232),
  },
  ticketStatus: {
    width: getRpx(85),
    height: getRpx(92),
    position: 'absolute',
    top: 0,
    right: 0,
  },
  ticketName: {
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',
    width: getRpx(446),
    paddingTop: getRpx(20),
    marginBottom: getRpx(20),
    elevation: 5,
  },
  ticketNameText: {
    width: getRpx(446),
    fontSize: getRpx(28),
    fontWeight: 'bold',
    lineHeight: getRpx(40),
    color: '#1A1A1A',
  },
  ticketType: {
    position: 'absolute',
    top: getRpx(28),
    left: 0,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    paddingLeft: getRpx(4),
    paddingRight: getRpx(4),
    height: getRpx(28),
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: '#4965F2',
    borderRadius: getRpx(6),
  },
  ticketTypeText: {
    color: '#4965F2',
    height: getRpx(28),
    lineHeight: getRpx(28),
    fontSize: getRpx(20),
  },
  ticketTypePlaceHolder: {
    color: 'transparent',
    fontSize: getRpx(20),
    alignItems: 'center',
    paddingLeft: getRpx(4),
    paddingRight: getRpx(4),
  },
  ticketGet: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: getRpx(446),
  },
  ticketDate: {
    width: getRpx(260),
    fontSize: getRpx(24),
  },
  ticketBtn: {
    width: getRpx(144),
    height: getRpx(56),
  },
  ticketBtnBg: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    width: getRpx(144),
    height: getRpx(56),
    borderRadius: getRpx(48),
  },
  ticketBtnBorder: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    borderWidth: getRpx(2),
    borderColor: '#4D76F4',
    borderStyle: 'solid',
    borderRadius: getRpx(48),
  },
  ticketBtnText: {
    fontSize: getRpx(24),
    alignItems: 'center',
  },
  ticketBtnColorWhite: {
    color: '#ffffff',
  },
  ticketBtnColorBlue: {
    color: '#4D76F4',
  },
  ball: {
    width: getRpx(16),
    height: getRpx(8),
    backgroundColor: '#fff',
    position: 'absolute',
    overflow: 'hidden',
    left: getRpx(200),
    elevation: 5,
  },
  ballRightTop: {
    top: 0,
    borderBottomLeftRadius: getRpx(8),
    borderBottomRightRadius: getRpx(8),
  },
  ballRightBot: {
    bottom: 0,
    borderTopLeftRadius: getRpx(8),
    borderTopRightRadius: getRpx(8),
  },
  descList: {
    paddingTop: getRpx(60),
    paddingBottom: getRpx(48),
  },
  desc: {
    width: getRpx(750),
    marginBottom: getRpx(60),
  },
  descTitle: {
    paddingLeft: getRpx(24),
    paddingRight: getRpx(24),
    height: Platform.OS == 'android' ? getRpx(35) : getRpx(28),
    lineHeight: Platform.OS == 'android' ? getRpx(35) : getRpx(28),
    fontSize: getRpx(28),
    fontWeight: 'bold',
    color: '#1A1A1A',
    marginBottom: getRpx(21),
  },
  descText: {
    paddingLeft: getRpx(24),
    paddingRight: getRpx(24),
    paddingTop: getRpx(4),
    paddingBottom: getRpx(4),
    lineHeight: Platform.OS == 'android' ? getRpx(28) : getRpx(30),
    fontSize: getRpx(24),
  },
  Button: {
    // position: 'absolute',
    // marginBottom: JDNativeSystem.isIPhoneX ? getRpx(78) : getRpx(100),
    // left: 0,
    width: getRpx(750),
    height: getRpx(100),
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#ffffff',
    zIndex: 12,
  },
  ButtonBg: {
    width: getRpx(678),
    height: getRpx(76),
    borderRadius: getRpx(42),
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden',
  },
  ButtonText: {
    fontSize: getRpx(26),
    color: '#ffffff',
    fontWeight: 'bold',
  },
});
interface IStoreProps {
  store: {
    entrySku: string;
    //动画value
    couponHeight: any;
    //动画value
    couponOpacity: any;
    ticket: ITicket;
    slideDownTicketDialog: () => void;
    handleHideTicketDialog: () => void;
    getCoupon: (c: AvailableCouponsItem) => void;
  };
}
interface IProps extends IStoreProps {}
interface IState {
  contentHeight: number;
  ticket: ITicket | null;
}
// couponType  京/东券 0-京券 1-东券
// couponOrg 默认或1-商城体系券  2-金融体系券
// 不同券颜色：京券（红）、东券（蓝）、金融券（金色）。
// 京券
const couJing = ['rgba(255,122,122,1)', 'rgba(255,79,79,1)'];
// 金融体系券
const couJR = ['rgba(245,208,131,1)', 'rgba(226,170,94,1)'];
// 东券
const couDong = ['rgba(93,159,225,1)', 'rgba(103,121,220,1)'];
class TicketLayer extends React.PureComponent<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      contentHeight: 0,
      ticket: null,
    };
  }
  componentWillMount() {
    const { ticket } = this.props.store;
    this.setState({ ticket });
  }
  UNSAFE_componentWillReceiveProps(nextProps: IProps) {
    if (nextProps.store.ticket) {
      console.log(nextProps.store.ticket);
      this.setState({ ticket: nextProps.store.ticket });
    }
  }
  slideDownTicketDialog = () => {
    this.props.store.slideDownTicketDialog();
  };
  hanldeGetCoupon = (c: AvailableCouponsItem) => {
    this.props.store.getCoupon(c);
    logClick({
      event_id: ContrastCoupon,
      event_param: '',
      page_param: this.props.store.entrySku,
    });
  };
  handleHideTicketDialog = () => {
    logClick({
      event_id: ContrastConfirm,
      event_param: '',
      page_param: this.props.store.entrySku,
    });
    this.props.store.slideDownTicketDialog();
  };
  couponType = (type: number) => {
    if (type == 0) {
      return couJing;
    }
    if (type == 1) {
      return couDong;
    }
    if (type == 2) {
      return couJR;
    }
    return [
      'rgba(87,155,250,1)',
      'rgba(85,148,249,1)',
      'rgba(80,131,246,1)',
      'rgba(75,111,243,1)',
      'rgba(73,101,242,1)',
    ];
  };
  _renderTicket = (t: AvailableCouponsItem, canUse: boolean) => {
    const { ticket } = this.state;
    if (!ticket) return;
    t.sku = ticket.sku;
    return (
      <View style={styles.ticket}>
        <View style={styles.ticketValue}>
          <LinearGradient
            colors={this.couponType(t.couponOrg ? t.couponOrg : t.couponKind)}
            start={{ x: 0, y: 0 }}
            end={{ x: 1, y: 0 }}
            style={styles.ticketValueBg}
          >
            <View style={styles.ticketPrice}>
              <JDText style={[styles.ticketPriceSymbol, styles.ticketColorWhite]}>
                {t.value ? t.value.substring(0, 1) : '-'}
              </JDText>
              <JDText style={[styles.ticketPriceNum, styles.ticketColorWhite]}>
                {t.value
                  ? t.value.substring(1).indexOf('.')
                    ? t.value.substring(1).split('.')[0]
                    : t.value.substring(1)
                  : '-'}
              </JDText>
            </View>
            <JDText style={[styles.ticketPriceRange, styles.ticketColorWhite]}>{t.discountValueDesc}</JDText>
          </LinearGradient>
        </View>
        <View style={styles.ticketInfo}>
          {canUse ? <JDImage source={Images.contrast.ticketReceived} style={styles.ticketStatus}></JDImage> : null}
          <View style={styles.ticketName}>
            <View style={styles.ticketType}>
              <JDText style={styles.ticketTypeText}>{t.couponTypeDesc}</JDText>
            </View>
            <JDText style={styles.ticketNameText}>
              <JDText style={styles.ticketTypePlaceHolder}>
                {t.couponTypeDesc}
                {/* 占位空格 */}
                {'     '}
                {/* 占位空格 */}
              </JDText>
              <JDText style={styles.ticketNameText}>{t.name}</JDText>
            </JDText>
          </View>
          <View style={styles.ticketGet}>
            <JDText style={styles.ticketDate} type={'JDZhengHT-Light'} numberOfLines={1}>
              {t.timeDesc}
            </JDText>
            {!canUse && Platform.OS !== 'web' ? (
              <JDTouchable style={styles.ticketBtn} onPress={this.hanldeGetCoupon.bind(this, t)}>
                <LinearGradient
                  colors={this.couponType(t.couponOrg ? t.couponOrg : t.couponKind)}
                  start={{ x: 0, y: 0 }}
                  end={{ x: 1, y: 0 }}
                  style={styles.ticketBtnBg}
                >
                  <JDText style={[styles.ticketBtnText, styles.ticketBtnColorWhite]}>立即领取</JDText>
                </LinearGradient>
              </JDTouchable>
            ) : null}
          </View>
        </View>
        <View style={[styles.ball, styles.ballRightBot]}></View>
        <View style={[styles.ball, styles.ballRightTop]}></View>
      </View>
    );
  };
  render() {
    const { store } = this.props;
    const { couponOpacity, couponHeight } = store;
    const { ticket } = this.state;
    const dis = this.state.contentHeight == 0 ? getRpx(1266) : this.state.contentHeight;
    return (
      <View style={styles.ticketLayer}>
        {Platform.OS != 'web' ? (
          <JDTouchable
            onPress={this.slideDownTicketDialog}
            style={{
              width: '100%',
              position: 'absolute',
              height: JDDevice.height - dis,
              top: 0,
              left: 0,
              zIndex: 100000,
              elevation: 100,
            }}
          />
        ) : null}
        <Animated.View
          style={[
            styles.mask,
            {
              opacity: couponOpacity,
            },
          ]}
        ></Animated.View>
        <Animated.View
          style={[styles.coupon, { height: Platform.OS == 'web' ? getRpx(1066) : couponHeight }]}
          onLayout={(e: any) => {
            const contentHeight = e.nativeEvent.layout.height;
            this.setState({
              contentHeight,
            });
          }}
        >
          <View style={styles.couponHead}>
            <JDText>优惠</JDText>
            <JDTouchable onPress={this.slideDownTicketDialog} style={styles.dialogCloseClick}>
              <JDImage source={Images.contrast.dialogClose} style={styles.dialogClose}></JDImage>
            </JDTouchable>
          </View>
          <View style={styles.dialogInner}>
            <JDScrollView bounces={false} showsVerticalScrollIndicator={false}>
              <View style={styles.dialogContent}>
                {ticket &&
                  ticket.availableCoupons &&
                  ticket.availableCoupons.map((t) => {
                    return this._renderTicket(t, false);
                  })}
                {ticket &&
                  ticket.hasAvailableCoupons &&
                  ticket.hasAvailableCoupons.map((t) => {
                    return this._renderTicket(t, true);
                  })}

                <View style={styles.descList}>
                  {ticket &&
                    ticket.exts &&
                    ticket.exts.map((t) => {
                      return (
                        <View style={styles.desc}>
                          <JDText style={styles.descTitle}>{t.name}</JDText>
                          <JDText style={styles.descText}>{t.value}</JDText>
                        </View>
                      );
                    })}
                </View>
              </View>
            </JDScrollView>
          </View>
          <View style={styles.Button}>
            <JDTouchable onPress={this.handleHideTicketDialog}>
              <LinearGradient
                colors={['rgba(242,20,12,1)', 'rgba(242,39,12,1)', 'rgba(242,77,12,1)']}
                start={{ x: 0, y: 0 }}
                end={{ x: 1, y: 0 }}
                style={styles.ButtonBg}
              >
                <JDText style={styles.ButtonText}>确定</JDText>
              </LinearGradient>
            </JDTouchable>
          </View>
        </Animated.View>
      </View>
    );
  }
}
const TicketLayerOberver = observer(TicketLayer);
const TicketLayerWapper = (props: IProps) => <TicketLayerOberver {...props} store={Store} />;
export default TicketLayerWapper;
